import React from 'react';
import ApplicationNavbarContext from '../application-navbar-context';

export default function Logo() {
  const { state: { userSignedIn } } = React.useContext(ApplicationNavbarContext);

  return (
    <div className="application-navbar-logo">
      <a
        href={userSignedIn ? '/feeds/latest' : '/'}
        className="application-navbar-logo-wrapper"
      >
        <img
          className="application-navbar-logo-image"
          alt="Livewire"
          src={window.getLivewireAssetPath('livewire-logo-wht.png')}
        />
      </a>
    </div>
  );
}
